import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
    KeyboardArrowLeft,
} from '@material-ui/icons';
import {
    inject, observer,
} from 'mobx-react';
import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import {
    RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
    FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
    countriesIsoCodes,
} from '../../constants/countries';
import {
    DefaultLanguage, getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
    translate,
} from '../../helperFunctions/translation';
import {
    ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
    IBranchStore,
} from '../../mobx-store/storeInterfaces/branchInterface';
import {
    IfacilitiesCategoriesStore,
} from '../../mobx-store/storeInterfaces/facilitiesCategoriesInterface';
import {
    IFacilityStore, MediaFile,
} from '../../mobx-store/storeInterfaces/facilitiesInterface';
import {
    CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditFacility.module.scss';
import {facilityTypes} from '../facilitiesMangementScreen/facilities';
import {AuthStore} from '../../mobx-store/stores/authStore';
import queryString from 'query-string';
import {
    IFacilitiesAreasStore,
} from '../../mobx-store/storeInterfaces/facilityAreaInterface';
import {IFacilityFormStore} from '../../mobx-store/storeInterfaces/facilityFormInterface';
import {IFacilityGroupStore} from "../../mobx-store/storeInterfaces/facilityGroupsInterface";


interface IProps extends WithSnackbarProps {
    facilityAreaStore: IFacilitiesAreasStore;
    facilityStore: IFacilityStore;
    branchStore: IBranchStore;
    authStore: AuthStore;
    facilityFormStore: IFacilityFormStore;
    countryStore: CountryStore;
    facilitiesCategoriesStore: IfacilitiesCategoriesStore;
    facilityGroupStore: IFacilityGroupStore;
    match: any;
    history: any;
    location: any;
}

interface IState {
    formFields: FormField[];
    FacilityCategories: any[];
    FacilityGroups: any[];
    loadingFacility: boolean;
    loadingBranches: boolean;
    loadingCategories: boolean;
    loadingGroups: boolean;
    loadingManagedCountries: boolean;
    processing: boolean;
    selectedLang: string;
    facilityType: any;
}

@inject('facilityStore')
@inject('branchStore')
@inject('countryStore')
@inject('facilityAreaStore')
@inject('authStore')
@inject('facilitiesCategoriesStore')
@inject('facilityGroupStore')
@inject('facilityFormStore')
@observer
class AddEditFacility extends Component<IProps & RouteComponentProps, IState> {
    isNew = false;

    isEgypt = false;

    facilityId = -1;

    pageTitle = '';

    lastHistory = -1;

    facilityFormTitle = '';

    facilitySchema: any;

    submitButton: any;

    cancelButton: any;

    facilityQueryType: string;

    initImagesGallery: MediaFile[] = [];

    initVideosGallery: MediaFile[] = [];

    initImages360Gallery: MediaFile[] = [];

    dropdownLanguages: {
        langList: { langCode: string; langValue: string } [];
        selectedLang: string;
        label: string;
        onChange(langCode: string): any;
    } | null = null;

    constructor(props: IProps & RouteComponentProps) {
        super(props);
        this.initializeComponent(props);
    }

    initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
        if (props.match.params.id) {
            this.isNew = false;
            this.facilityId = props.match.params.id;
            this.pageTitle = translate('editFacilityPageTitle', {});
        } else {
            this.isNew = true;
            this.pageTitle = translate('addFacilityPageTitle', {});
        }
        this.initFacilitySchema();
        this.initState(isConstructor);
        this.submitButton = this.getSubmitButton();
        this.cancelButton = this.getCancelButton();
        this.facilityFormTitle = translate('FacilityPageFormTitle', {});
        this.dropdownLanguages = this.getDropdownLanguages();
    }

    async componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
        if (this.props.location.pathname !== nextProps.location.pathname) {
            this.lastHistory = -2;
            this.initializeComponent(nextProps, false);
            this.setState({
                loadingManagedCountries: false,
            });
            this.forceUpdate();
            const {
                countryStore,
                facilitiesCategoriesStore,
                facilityGroupStore,
                facilityAreaStore,
                branchStore,
                facilityFormStore,
            } = this.props;
            await Promise.all([
                facilityAreaStore.getFacilityAreas(countryStore.managedCountries),
                facilitiesCategoriesStore.getFacilityCategories(countryStore.managedCountries, this.facilityQueryType),
                facilityGroupStore.getFacilityGroups(countryStore.managedCountries, this.facilityQueryType),
                branchStore.getBranches(countryStore.managedCountries),
                facilityFormStore.getAll(countryStore.managedCountries),
            ]).then(() => {
                this.updateStateWithBranchesData();
                this.updateStateWithCategoriesData();
                this.updateStateWithGroupsData();
                this.updateStateWithFacilityAreasData();
                // this.updateStateWithFacilityFormsData();
            }).catch(() => {
                this.setState({
                    loadingBranches: false,
                    loadingCategories: false,
                });
            });
            this.setState({
                loadingManagedCountries: false,
                facilityType: this.facilityQueryType,
            });
            if (!this.isNew) {
                this.getFacility(languageCodes.english);
            }
        }
    }

    getDropdownLanguages = () => {
        if (this.isNew) {
            return null;
        }
        return {
            langList: getDropdownLanguagesList(),
            selectedLang: this.state.selectedLang,
            label: 'Select Languages',
            onChange: this.handelLanguageChange,
        };
    };

    handelLanguageChange = (langCode: string) => {
        if (this.isNew) {
            this.setState({
                selectedLang: langCode,
            });
        } else {
            this.getFacility(langCode);
        }
    };

    initFacilitySchema = () => {
        this.facilitySchema = Yup.object().shape({
            name: Yup.string().required('Required'),
            isActive: Yup.boolean().default(true),
            facilityCategory: Yup.number().required('Required'),
            facilityGroup: Yup.number(),
            branchId: Yup.number(),
            facilityAreaId: Yup.number(),
            questionsFormId: Yup.number(),
            imageUrl: Yup.array(),
            images: Yup.array(),
            videos: Yup.array(),
            images360: Yup.array(),
        });
    };

    getFormFields = (): FormField[] => {
        const formFields: FormField[] = [
            {
                name: 'name',
                label: this.isNew && this.isEgypt ? translate('FacilityPageFormArabicTitleLabel', {}) : translate('FacilityPageFormTitleLabel', {}),
                type: 'text',
                filedType: 'InputField',
            },
            {
                name: 'facilityCategory',
                label: translate('FacilityPageFormFacilityCategories', {}),
                selectList: [],
                selectListValue: 'title',
                selectListKey: 'facilityCategoryId',
                filedType: 'DropdownField',
            },

            {
                name: 'imageUrl',
                label: translate('addAcademyPageFormBackgroundImage', {}),
                filedType: 'GalleryField',
                isLimitToOneImage: true,
                accept: 'image/*',
                size: 200,
            },
            {
                name: 'isActive',
                label: translate('FacilityPageFormStatus', {}),
                filedType: 'ToggleButtonField',
                activeLabel: translate('FacilityPageFormActiveLabel', {}),
                inactiveLabel: translate('FacilityPageFormActiveLabel', {}),
                value: true,
            },
        ];
        if (this.facilityQueryType === facilityTypes.MARKETING) {
            formFields.push(
                {
                    name: 'branchId',
                    label: translate('FacilityPageFormAvailableBranches', {}),
                    selectList: [],
                    selectListValue: 'title',
                    selectListKey: 'id',
                    filedType: 'DropdownField',
                },
                {
                    name: 'images',
                    label: translate('addBranchPageFormGalleryImages', {}),
                    filedType: 'GalleryField',
                    accept: 'image/*',
                    size: 512,
                    value: (this.isNew ? [] : this.props.facilityStore.selectedFacility.images),
                },
                {
                    name: 'videos',
                    label: translate('addBranchPageFormGalleryVideos', {}),
                    filedType: 'GalleryField',
                    accept: 'video/*',
                    size: 10240,
                    value: (this.isNew ? [] : this.props.facilityStore.selectedFacility.videos),
                },
                {
                    name: 'images360',
                    label: translate('addBranchPageFormGalleryImages360', {}),
                    filedType: 'GalleryField',
                    accept: 'image/*',
                    size: 5120,
                    value: (this.isNew ? [] : this.props.facilityStore.selectedFacility.images360),
                },
            );
        } else if (this.facilityQueryType === facilityTypes.RATING) {
            formFields.push(
                {
                    name: 'facilityArea',
                    label: translate('FacilityPageFormFacilityAreas', {}),
                    selectList: [],
                    selectListValue: 'title',
                    selectListKey: 'facilityAreaId',
                    filedType: 'DropdownField',

                },
                {
                    name: 'facilityGroup',
                    label: translate('FacilityPageFormFacilityGroup', {}),
                    selectList: [],
                    selectListValue: 'title',
                    selectListKey: 'FacilityGroupId',
                    filedType: 'DropdownField',
                },
                // {
                //   name: 'facilityForm',
                //   label: translate('FacilityPageFormFacilityForms', {
                //   }),
                //   selectList: [],
                //   selectListValue: 'title',
                //   selectListKey: 'questionsFormId',
                //   filedType: 'DropdownField',
                //
            );
        }

        return formFields;
    };

    initState = (isConstructor = true) => {
        const initState: IState = {
            processing: false,
            loadingFacility: !this.isNew,
            loadingManagedCountries: true,
            loadingBranches: true,
            loadingCategories: true,
            FacilityCategories: [],
            loadingGroups: true,
            FacilityGroups: [],
            selectedLang: languageCodes.english,
            facilityType: queryString.parse(this.props.location.search).type,
            formFields: this.getFormFields(),
        };
        if (isConstructor) {
            this.state = initState;
        } else {
            this.setState(initState);
        }
    };

    getQueryParam = () => {
        const queryValues = queryString.parse(this.props.location.search);
        const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;

        return facilityTypeToCall;
    }

    handleSubmit = (values: any): void => {
        const {
            countryStore,
        } = this.props;
        values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

        this.setState({
            processing: true,
        });

        values.facilityType = this.state.facilityType;

        if (this.isNew) {
            this.props.facilityStore.createFacility(values)
                .then((facilityId) => {
                    if (this.isEgypt) {
                        this.props.history.push(`${facilityId}/edit`);
                    } else {
                        this.props.history.go(this.lastHistory);
                    }
                }).catch((error) => {
                console.log(error);
                this.setState({
                    processing: false,
                });
                SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 5000, 'error');
            });
        } else {
            this.props.facilityStore.updateFacility(values, this.facilityId,
                this.initImagesGallery, this.initVideosGallery, this.initImages360Gallery, this.state.selectedLang,
            ).then(() => {
                this.setState({
                    processing: false,
                });
                SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {}), 5000, 'success');
                this.props.history.go(this.lastHistory);
            }).catch(() => {
                this.setState({
                    processing: false,
                });
                SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 5000, 'error');
            });
        }
    };

    navigateBack = () => {
        this.props.history.goBack();
    };

    getSubmitButton = () => ({
        title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
        onSubmit: this.handleSubmit,
    });

    getCancelButton = () => ({
        title: 'Cancel',
        onCancel: this.navigateBack,
    });

    updateStateWithFacilityData = () => {
        const formFieldsWithData = this.state.formFields.map((field) => ({
            ...field,
            value: this.props.facilityStore.selectedFacility[field.name],
        }));
        this.initImagesGallery = Object.assign([], this.props.facilityStore.selectedFacility.images);
        this.initVideosGallery = Object.assign([], this.props.facilityStore.selectedFacility.videos);
        this.initImages360Gallery = Object.assign([], this.props.facilityStore.selectedFacility.images360);
        this.setState({
            formFields: formFieldsWithData, loadingFacility: false,
        });
    };

    updateStateWithBranchesData = () => {
        const formFieldsWithData = [];
        for (const field of this.state.formFields) {
            if (field.name === 'branchId') {
                formFieldsWithData.push(
                    {
                        ...field, selectList: this.props.branchStore.branchesList,
                    },
                );
            } else {
                formFieldsWithData.push(field);
            }
        }
        this.setState({
            formFields: formFieldsWithData, loadingBranches: false,
        });
    };

    updateStateWithCategoriesData = () => {
        const formFieldsWithData = [];
        for (const field of this.state.formFields) {
            if (field.name === 'facilityCategory') {
                formFieldsWithData.push(
                    {
                        ...field, selectList: this.props.facilitiesCategoriesStore.categoriesList,
                    },
                );
            } else {
                formFieldsWithData.push(field);
            }
        }
        this.setState({
            formFields: formFieldsWithData,
            loadingCategories: false,
        });
    };
    updateStateWithGroupsData = () => {
        const formFieldsWithData = [];
        for (const field of this.state.formFields) {
            if (field.name === 'facilityGroup') {
                formFieldsWithData.push(
                    {
                        ...field, selectList: this.props.facilityGroupStore.groupsList,
                    },
                );
            } else {
                formFieldsWithData.push(field);
            }
        }
        this.setState({
            formFields: formFieldsWithData,
            loadingCategories: false,
        });
    };

    updateStateWithFacilityAreasData = () => {
        const formFieldsWithData = [];
        const areas = this.updateAreasNames();
        for (const field of this.state.formFields) {
            if (field.name === 'facilityArea') {
                formFieldsWithData.push(
                    {
                        ...field,
                        selectList: areas,
                    },
                );
            } else {
                formFieldsWithData.push(field);
            }
        }
        this.setState({
            formFields: formFieldsWithData,
            loadingCategories: false,
        });
    };

    updateStateWithFacilityFormsData = () => {
        const formFieldsWithData = [];
        for (const field of this.state.formFields) {
            if (field.name === 'facilityForm') {
                formFieldsWithData.push(
                    {
                        ...field,
                        selectList: this.props.facilityFormStore.facilityForms,
                    },
                );
            } else {
                formFieldsWithData.push(field);
            }
        }
        this.setState({
            formFields: formFieldsWithData,
        });
    };


    getFormHeader = () => (
        <div className={classes.header}>
            <IconButton
                className={classes.backButton}
                onClick={() => this.props.history.goBack()}
                aria-label="Back"
            >
                <KeyboardArrowLeft/>
            </IconButton>
            <Typography className={classes.title} variant="h6" gutterBottom>
                {this.pageTitle}
            </Typography>
        </div>
    );
      onChangeValues=(key:any, value:number)=>{

      if (key==="facilityArea"){
          const {
              countryStore,
              facilityGroupStore, } = this.props;
            countryStore.getUserManagedCountries();

            Promise.all([
              facilityGroupStore.getFacilityGroups(countryStore.managedCountries, this.facilityQueryType, languageCodes.english,value),
          ]).then(() => {
              this.updateStateWithGroupsData();
          }).catch(() => {
              this.setState({
                  loadingBranches: false,
                  loadingCategories: false,
              });
          });

      }
    }
    render() {
        return (
            <div className={classes.container}>
                {this.getFormHeader()}
                <div className={classes.content}>
                    {this.state.loadingFacility || this.state.loadingManagedCountries
                        ? <Spinner/>
                        : (
                            <GeneralFormComponent
                                dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                                formTitle={this.facilityFormTitle}
                                fields={this.state.formFields}
                                formSchema={this.facilitySchema}
                                submitButton={this.submitButton}
                                cancelButton={this.cancelButton}
                                processing={this.state.processing}
                                onChangeValues={(key: any, value: any) => this.onChangeValues(key, value)}
                            />
                        )}
                </div>
            </div>
        );
    }

    async componentDidMount() {
        const {
            countryStore,
            facilitiesCategoriesStore,
            facilityGroupStore,
            facilityAreaStore,
            branchStore,
            facilityFormStore,
        } = this.props;

        this.facilityQueryType = this.getQueryParam();

        await countryStore.getUserManagedCountries();
        if (this.props.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
            this.isEgypt = true;
        }
        this.initState();
        this.submitButton = this.getSubmitButton();

        await Promise.all([
            facilityAreaStore.getFacilityAreas(countryStore.managedCountries),
            facilitiesCategoriesStore.getFacilityCategories(countryStore.managedCountries, this.facilityQueryType),
             branchStore.getBranches(countryStore.managedCountries),
            facilityFormStore.getAll(countryStore.managedCountries)
        ]).then(() => {
            this.updateStateWithBranchesData();
            this.updateStateWithCategoriesData();
             this.updateStateWithFacilityAreasData();
            // this.updateStateWithFacilityFormsData();
        }).catch(() => {
            this.setState({
                loadingBranches: false,
                loadingCategories: false,
            });
        });
        this.setState({
            loadingManagedCountries: false,
            facilityType: this.facilityQueryType,
        });
        if (!this.isNew) {
            this.getFacility(DefaultLanguage);
        }
    }

    updateAreasNames = () => {
        const areas = this.props.facilityAreaStore.facilitiesAreas.map(area => {
            return {
                ...area,
                title: `${area.title} - ${area.branch.title}`
            }
        });
        return areas;
    };

    getFacility = (langCode: string) => {
        this.setState({
            loadingFacility: true,
        });
        const {
            countryStore,
            facilityStore,
            facilityGroupStore,
            facilitiesCategoriesStore,
            branchStore,
            facilityAreaStore,
            facilityFormStore,
        } = this.props;
        Promise.all([
            facilityStore.getFacilityById(this.facilityId, langCode),
            facilitiesCategoriesStore.getFacilityCategories(countryStore.managedCountries, this.facilityQueryType, langCode),
            facilityGroupStore.getFacilityGroups(countryStore.managedCountries, this.facilityQueryType, langCode),
            branchStore.getBranches(countryStore.managedCountries, langCode),
            facilityAreaStore.getFacilityAreas(countryStore.managedCountries, langCode),
            facilityFormStore.getAll(countryStore.managedCountries, langCode),
        ])
            .then(() => {
                this.updateStateWithFacilityData();
                this.updateStateWithBranchesData();
                this.updateStateWithCategoriesData();
                this.updateStateWithGroupsData();
                this.updateStateWithFacilityAreasData();
                // this.updateStateWithFacilityFormsData();
                this.dropdownLanguages!.selectedLang = langCode;
                this.setState({
                    selectedLang: langCode,
                });
            }).catch(() => {
            this.setState({
                loadingFacility: false,
            });
        });
    };
}

export default withRouter(AddEditFacility);
